import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiConnector } from "../apiConnector";
import { toast } from "react-toastify";
import { endpoint } from "../apis";
import Cookies from "js-cookie";

export const userProfile = createAsyncThunk(
  "userProfile/action",
  async ({ actionType, data }, { rejectWithValue }) => {
    try {
      // const token = localStorage.getItem("token");
       const token = Cookies.get('authToken');
      let payload;

      switch (actionType) {
        case "list": // Changed from "list" to "getProfile"
          payload = {
            action: "list",
            account_id: data?.account_id // Include account_id if available
          };
          break;

        case "create":
          payload = {
            action: "create",
            ...data, // Company details for creation
          };
          break;

        case "update":
          payload = {
            action: "update",
            ...data, // Updated company details
          };
          break;

        case "delete":
          payload = {
            action: "delete",
            company_id: data.company_id, // ID required for deletion
          };
          break;

        default:
          return rejectWithValue("Invalid action type");
      }

      const response = await apiConnector(
        "post",
        endpoint.USER_PROFILE, // API endpoint
        payload,
        { Authorization: `Bearer ${token}` }
      );


      if (response.data.Response) {
        switch (actionType) {
          case "list":
            // toast.success("Company profile fetched successfully!");
            return { actionType, data: response.data.Response.companies };

          case "create":
            toast.success(`Company ${data.name} created successfully!`);
            return { actionType, data: response.data };

          case "update":
            toast.success(`Company ${data.name} updated successfully!`);
            return { actionType, data: response.data };

          case "delete":
            toast.success("Company deleted successfully!");
            return { actionType, company_id: data.company_id };

          default:
            return rejectWithValue("Invalid action type");
        }
      } else {
        return rejectWithValue("Unexpected response format.");
      }
    } catch (error) {
      if (error?.response?.data === "('Token has been expired',)") {
        localStorage.clear();
        const frontendUrl = process.env.REACT_APP_FRONTEND_URL || 'http://www.katalisia.com';
        window.location.href = frontendUrl;
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error.response?.data || "API request failed.");
      }
      return rejectWithValue(error.response?.data || "API request failed.");
    }
  }
);
